var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M316.035 271.013c0 41.381-33.666 75.047-75.047 75.047s-75.047-33.666-75.047-75.047c0-41.382 33.666-75.049 75.047-75.049 15.277 0 29.495 4.6 41.364 12.471l43.522-43.522a172.899 172.899 0 0 0-2.973-2.135c-29.515-20.625-59.081-31.049-88.002-31.049-2.649 0-5.291.087-7.929.262-34.896 2.375-67.406 17.91-91.519 43.741-24.173 25.854-37.481 59.688-37.481 95.281 0 38.188 14.88 74.1 41.898 101.118 27.02 27.02 62.931 41.899 101.119 41.899s74.1-14.88 101.119-41.899c27.018-27.019 41.897-62.93 41.897-101.118 0-31.434-12.694-61.612-35.612-86.193l-44.829 44.828c7.874 11.869 12.473 26.088 12.473 41.365z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.382 260.406 30.032-30.032a44.768 44.768 0 0 0-19.425-4.41c-24.839 0-45.047 20.209-45.047 45.049 0 24.839 20.208 45.047 45.047 45.047s45.047-20.208 45.047-45.047a44.786 44.786 0 0 0-4.409-19.426l-30.031 30.031z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.284 144.929-18.664 18.664c28.543 30.221 44.385 67.885 44.385 107.42 0 46.202-18 89.646-50.685 122.331-32.686 32.686-76.131 50.687-122.332 50.687s-89.646-18.001-122.332-50.687C85.97 360.659 67.97 317.214 67.97 271.013c0-43.228 16.181-84.339 45.56-115.761 29.313-31.404 68.89-50.299 111.429-53.194 38.451-2.541 77.171 9.606 115.126 36.13a200.233 200.233 0 0 1 7.213 5.302l19.774-19.774 3.167-56.191c-38.274-24.416-82.755-37.5-129.25-37.5-64.37 0-124.888 25.067-170.404 70.583C25.067 146.124 0 206.642 0 271.012S25.067 395.9 70.584 441.416 176.618 512 240.988 512s124.888-25.067 170.404-70.584 70.583-106.034 70.583-170.404c0-46.495-13.085-90.976-37.5-129.25z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.646 114.354 61.298-3.455L512 57.842 454.159 0l-53.057 53.056z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.50d18b5f4c98d4b98abd76e129eb976f.svg";
export { ForwardRef as ReactComponent };